import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";

const WalletStatusFilter = ({
    value,
    onChange,
    disabled = false,
    showAllOption = true,
    allowClear = true,
    hideTitle = false,
    marginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation([]);

    return (
        <React.Fragment>
            {!hideTitle && <h5>Cüzdan Durumu</h5>}
            <SelectField
                data-testid="walletStatusSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                allowClear={allowClear}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="walletStatusSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                <SelectField.Option value="true" data-testid="walletStatusSelect_option">
                    Cüzdanda Var
                </SelectField.Option>
                <SelectField.Option value="false" data-testid="walletStatusSelect_option">
                    Cüzdanda Yok
                </SelectField.Option>
            </SelectField>
        </React.Fragment>
    );
};

export default WalletStatusFilter;
